export const searchArray = function(data,search,column=[]){
  let sumData=[];
  data.forEach(element => {
    let sum="";
    Object.keys(element).forEach(key => {
      if(column.length==0){
        sum+=' '+element[key];
      }else{
        column.forEach(clm => {
          if(clm.name==undefined){
            if(column.indexOf(key)>-1){
              sum+=' ' +element[key];
            }
          }else{
            if(clm.isArray!=undefined){
              var arraySum="";
              clm.isArray.forEach(arrKey => {
                element[clm.name].forEach((arrItem,index) => {
                  arraySum+=(index==0?"":";")+arrItem[arrKey];
                });
              });
              sum+=' ' +arraySum;
            }
            if(clm.isDate!=undefined){
              if(clm.isDate=="DD.MM.YYYY"){
                var date=new Date(element[clm.name]);
                sum+=" "+(date.getDate().toString().length<2?"0"+date.getDate():date.getDate()) + "." + ((date.getMonth()+1).toString().length<2?"0"+(date.getMonth()+1):(date.getMonth()+1))+ "." +date.getFullYear();
              }
              if(clm.isDate=="DD.MM.YYYY HH:MM"){
                sum+=" "+(date.getDate().toString().length<2?"0"+date.getDate():date.getDate()) + "." + ((date.getMonth()+1).toString().length<2?"0"+(date.getMonth()+1):(date.getMonth()+1))+ "." +date.getFullYear()+ " " +(date.getHours().toString().length<2?"0"+date.getHours():date.getHours())+":"+(date.getMinutes().toString().length<2?"0"+date.getMinutes():date.getMinutes());
              }
              // sum+=' '+element[clm.name];
            }
            if(clm.isBoolean!=undefined){
              if(element[clm.name]){
                sum+=" "+clm.isBoolean[0];
              }else{
                sum+=" "+clm.isBoolean[1];
              }
            }
          }
        });
        // if(column.indexOf(key)>-1){
        //   sum+=' ' +JSON.stringify(element[key]);
        // }
      }
    });
    sumData.push(sum);
  });
  let searchData=[];
  var app=this;
  sumData.forEach(function(element,index) {
    if(app.$turkishReplaces(element).toUpperCase().indexOf(app.$turkishReplaces(search).toUpperCase())>-1){
      searchData.push(data[index]);
    }
  });
  return searchData;
}